import { useEffect, useState } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { GenericDataTable } from 'helpers/generic-data-table'
import { messagesColumns } from 'helpers/messages-columns'
import { fetchMessages } from 'store/messages/messagesSlice'
import { useAppDispatch, useAppSelector } from 'store/store'

const MessagesPage = () => {
  const dispatch = useAppDispatch()
  const { totalPages, messagesList } = useAppSelector((state) => state.messages)

  const [pageIndex, setPageIndex] = useState(0) // React Table usa indice 0-based
  const pageSize = 20

  useEffect(() => {
    // Aggiungiamo +1 perché l'API usa le pagine a partire da 1, mentre la tabella parte da 0
    dispatch(fetchMessages(pageIndex + 1))
  }, [pageIndex, dispatch])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>Messaggi</h2>
            <p className='text-muted-foreground'>
              Visualizza lo storico e il contenuto dei messaggi della
              piattaforma
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <GenericDataTable
            columns={messagesColumns()}
            data={messagesList || []}
            pageCount={totalPages}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onPageIndexChange={setPageIndex}
          />
        </div>
      </Main>
    </>
  )
}

export default MessagesPage
